import React, { useState, ChangeEvent, useRef, useEffect } from "react";
import {
  HttpGet,
  HttpPost,
  HttpPostFile,
  HttpPut,
} from "../../providers/HttpClient";
import Alert from "../alertComponent/alertComponent";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import { FaCar, FaUser, FaCalendarAlt, FaRegImage } from "react-icons/fa";
// import { MdCategory } from "react-icons/md";

interface VehicleFormData {
  category: string;
  categoryOwner: string;
  driverName: string;
  licenseNumber: string;
  inDate: string;
  note: string;
  firstInPicture: File | null;
  secondInPicture: File | null;
}

interface VehicleFormDataOut {
  category: "";
  categoryOwner: "";
  driverName: "";
  licenseNumber: "";
  outDate: "";
  note: "";
  firstOutPicture: File | null;
  secondOutPicture: File | null;
}

const VehicleRecordForm: React.FC = () => {
  const navigate = useNavigate();
  const [companyProfile, setCompanyProfile] = useState<any>(
    JSON.parse(localStorage.getItem("companyProfile")),
  );
  const id = useParams();
  const [loading, setLoading] = useState(false);
  const [alertType, setAlertType] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [imageUrl1, setImageUrl1] = useState(null);
  const [imageUrl2, setImageUrl2] = useState(null);
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const inputRef2 = useRef<HTMLInputElement | null>(null);
  const [imageName1, setImageName1] = useState("");
  const [imageName2, setImageName2] = useState("");
  const [photoTo, setPhotoTo] = useState("");
  const [loadingImage1, setLoadingImage1] = useState(false);
  const [loadingImage2, setLoadingImage2] = useState(false);
  const [formData, setFormData] = useState<VehicleFormData>({
    category: "",
    categoryOwner: "",
    driverName: "",
    licenseNumber: "",
    inDate: "",
    note: "",
    firstInPicture: null,
    secondInPicture: null,
  });
  const [formDataOut, setFormDataOut] = useState<VehicleFormDataOut>({
    category: "",
    categoryOwner: "",
    driverName: "",
    licenseNumber: "",
    outDate: "",
    note: "",
    firstOutPicture: null,
    secondOutPicture: null,
  });

  const closeAction = async () => {
    setOpen(false);
    navigate("/home");
  };

  const alert = (message, type, subMessage) => {
    setOpen(true);
    setAlertMessage(message);
    setAlertType(type);
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClick = () => {
    inputRef?.current?.click();
    setPhotoTo("1");
  };

  const handleClick2 = () => {
    inputRef2?.current?.click();
    setPhotoTo("2");
  };

  const uploadChoosenPhoto = async (event) => {
    let formData = new FormData();
    formData.append("image", event.target.files[0]);

    if (photoTo === "1") {
      setLoadingImage1(true);
    } else if (photoTo === "2") {
      setLoadingImage2(true);
    }
    setLoading(true);
    HttpPostFile(`member/images?feature=log`, formData)
      .then((res: any) => {
        const file = event.target.files[0];
        if (!file) return;

        const previewUrl = URL.createObjectURL(file);
        if (photoTo === "1") {
          setImageUrl1(previewUrl);
          setImage1(res.data);
          setLoadingImage1(false);
        }
        if (photoTo === "2") {
          setImageUrl2(previewUrl);
          setImage2(res.data);
          setLoadingImage2(false);
        }
        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    let data = {
      ...formData,
      inDate: formData.inDate,
      firstInPicture: image1,
      secondInPicture: image2,
    };

    let outData = {
      ...formDataOut,
      category: formData.category,
      categoryOwner: formData.categoryOwner,
      outDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
      licenseNumber: formData.licenseNumber,
      driverName: formData.driverName,
      firstOutPicture: image1,
      secondOutPicture: image2,
    };
    if (id.id != "add") {
      setLoading(true);
      HttpPut(`member/log_vehicle/checkout/${id.id}`, outData)
        .then((res: any) => {
          setLoading(false);

          alert("Log Keluar Kendaraan Berhasil", true, "");
        })
        .catch((err: any) => {
          setLoading(false);
        });
    } else {
      setLoading(true);

      HttpPost("member/log_vehicle", data)
        .then((res: any) => {
          setLoading(false);

          alert("Log Masuk Kendaraan Berhasil", true, "");
        })
        .catch((err: any) => {
          setLoading(false);
        });
    }
  };

  const getDetail = () => {
    HttpGet("member/log_vehicle/" + id.id)
      .then((res: any) => {
        setFormData({
          ...res.data,
          inDate: res.data.inDate,
        });
        let image1 = res.data.firstOutPicture
          ? res.data.firstOutPicture
          : res.data.firstInPicture;

        let image2 = res.data.secondOutPicture
          ? res.data.secondOutPicture
          : res.data.secondinPicture;
        // setImageUrl1(image1);
        // setImageUrl2(image2);
      })
      .catch((err: any) => {
        console.log("Error saat kirim log:", err);
      });
  };

  useEffect(() => {
    if (id.id !== "add") {
      getDetail();
    }
  }, [id]);
  return (
    <>
      <Alert
        type={alertType}
        isOpen={open}
        closeAction={closeAction}
        message={alertMessage}
        subMessage={""}
      />
      <header
        style={{ backgroundColor: companyProfile?.color }}
        className="text-white text-center py-5"
      >
        <h2 className="text-xl font-semibold">Pencatatan Kendaraan</h2>
        <p className="text-sm opacity-80">Sistem Manajemen Keluar Masuk</p>
      </header>
      <section id="main" className="bg-main h-full px-8 pb-24 -mt-28 z-50">
        <div className="mt-32 z-100 z-30 mb-4">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {/* <FaCalendarAlt className="inline-block mr-2 text-purple-600" /> */}
              Tanggal & Waktu
            </label>
            <input
              type="datetime-local"
              name="inDate"
              value={formData.inDate}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {/* <MdCategory className="inline-block mr-2 text-purple-600" /> */}
              Kategori Kendaraan
            </label>
            <select
              disabled={id.id != "add"}
              name="category"
              value={formData.category}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            >
              <option value="">Pilih kategori kendaraan</option>
              <option value="MOBIL">Mobil</option>
              <option value="MOTOR">Motor</option>
              <option value="TRUK">Truk</option>
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {/* <FaUser className="inline-block mr-2 text-purple-600" /> */}
              Kategori Pemilik Kendaraan
            </label>
            <select
              disabled={id.id != "add"}
              name="categoryOwner"
              value={formData.categoryOwner}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            >
              <option value="">Pilih kategori pemilik</option>
              <option value="KARYAWAN">Karyawan</option>
              <option value="TAMU">Tamu</option>
              <option value="LAINNYA">Lainnya</option>
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {/* <FaUser className="inline-block mr-2 text-purple-600" /> */}
              Nama Pengemudi
            </label>
            <input
              type="text"
              name="driverName"
              placeholder="Masukkan nama pengemudi"
              value={formData.driverName}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Plat Nomor Kendaraan
            </label>
            <input
              type="text"
              name="licenseNumber"
              placeholder="CONTOH: B 1234 XYZ"
              value={formData.licenseNumber}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500 uppercase"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {/* <FaRegImage className="inline-block mr-2 text-purple-600" /> */}
              Foto Kendaraan
            </label>
            <label className="text-sm font-light text-gray-400 mb-2">
              {/* <FaRegImage className="inline-block mr-2 text-purple-600" /> */}
              Foto 1
            </label>
            <div hidden={loadingImage1 == false}>
              <Skeleton
                containerClassName="border-2 border-gray-400 border-dashed flex justify-center relative bg-white rounded-2xl"
                baseColor="#000000"
                highlightColor="#363434"
                className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                style={{ borderRadius: 12 }}
              />
            </div>
            {loadingImage1 == false ? (
              <div
                // key={num}
                onClick={() => handleClick()}
                className="border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center p-6 mb-3 text-gray-500 cursor-pointer hover:border-purple-500"
              >
                <img
                  hidden={!imageUrl1}
                  src={imageUrl1 ? `${imageUrl1}` : null}
                  className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                />
                <input
                  type="file"
                  ref={inputRef}
                  accept="image/*"
                  capture
                  style={{ display: "none" }}
                  id="photo"
                  name="photo"
                  // onChange={inputHandler}
                  onChange={(event) => uploadChoosenPhoto(event)}
                  placeholder="pilih foto"
                />
                <label
                  // htmlFor={`photo`}
                  className="flex flex-col items-center cursor-pointer"
                >
                  {/* <FaRegImage className="text-3xl mb-2 text-gray-400" /> */}
                  <span>Tap untuk mengambil foto (Foto)</span>
                </label>
              </div>
            ) : null}
            <label className="text-sm font-light text-gray-400 mb-2">
              {/* <FaRegImage className="inline-block mr-2 text-purple-600" /> */}
              Foto 2
            </label>
            <div hidden={loadingImage2 == false}>
              <Skeleton
                containerClassName="border-2 border-gray-400 border-dashed flex justify-center relative bg-white rounded-2xl"
                baseColor="#000000"
                highlightColor="#363434"
                className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                style={{ borderRadius: 12 }}
              />
            </div>
            {loadingImage2 == false ? (
              <div
                // key={num}
                onClick={() => handleClick2()}
                className="border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center p-6 mb-3 text-gray-500 cursor-pointer hover:border-purple-500"
              >
                <img
                  hidden={!imageUrl2}
                  src={imageUrl2 ? `${imageUrl2}` : null}
                  className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                />
                <input
                  type="file"
                  ref={inputRef2}
                  accept="image/*"
                  capture
                  style={{ display: "none" }}
                  id="photo2"
                  name="photo2"
                  // onChange={inputHandler}
                  onChangeCapture={(event) => uploadChoosenPhoto(event)}
                  placeholder="pilih foto"
                />
                <label
                  // htmlFor={`photo2`}
                  className="flex flex-col items-center cursor-pointer"
                >
                  {/* <FaRegImage className="text-3xl mb-2 text-gray-400" /> */}
                  <span>Tap untuk mengambil foto (Foto)</span>
                </label>
              </div>
            ) : null}
          </div>
        </div>
        {/* <form
          onSubmit={handleSubmit}
          className="w-full max-w-md bg-white rounded-2xl shadow-lg overflow-hidden"
        > */}

        {/* </form> */}
      </section>
      <div className="fixed bottom-0 w-full bg-white px-4 py-5 z-[9999]">
        {loading ? (
          <button
            disabled
            type="submit"
            className="w-full text-white font-semibold py-3 rounded-lg hover:bg-purple-800 bg-gray-300 transition"
          >
            Simpan Data
          </button>
        ) : (
          <button
            style={{ backgroundColor: companyProfile?.color }}
            disabled={loading}
            onClick={handleSubmit}
            type="submit"
            className="w-full text-white font-semibold py-3 rounded-lg hover:bg-purple-800 transition"
          >
            Simpan Data
          </button>
        )}
      </div>
    </>
  );
};

export default VehicleRecordForm;
